import styled from 'styled-components';
import { node, bool } from 'prop-types';
import { C_LUNAR } from '@bbc/psammead-styles/colours';
import { GEL_SPACING, GEL_SPACING_DBL, GEL_SPACING_TRPL } from '@bbc/gel-foundations/spacings';
import { GEL_GROUP_3_SCREEN_WIDTH_MIN, GEL_GROUP_3_SCREEN_WIDTH_MAX, GEL_GROUP_4_SCREEN_WIDTH_MIN } from '@bbc/gel-foundations/breakpoints';
export var StoryPromoLi = /*#__PURE__*/styled.li.attrs({
  role: 'listitem'
}).withConfig({
  displayName: "StoryPromoLi",
  componentId: "sc-171lqjd-0"
})(["@media (max-width:", "){border-bottom:0.0625rem solid ", ";}", " padding:", " 0 ", ";@media (min-width:", "){padding:", " 0 ", ";}@media (min-width:", "){padding:0 0 ", ";}&:first-child{padding-top:0;@media (min-width:", ") and (max-width:", "){padding-top:", ";}}&:last-child{padding-bottom:0;border:none;}"], GEL_GROUP_3_SCREEN_WIDTH_MAX, C_LUNAR, function (_ref) {
  var border = _ref.border;
  return !border && "\n      @media (min-width: ".concat(GEL_GROUP_3_SCREEN_WIDTH_MIN, ") and (max-width: ").concat(GEL_GROUP_3_SCREEN_WIDTH_MAX, ") {\n          border-bottom: none;\n      }\n    ");
}, GEL_SPACING, GEL_SPACING_DBL, GEL_GROUP_3_SCREEN_WIDTH_MIN, GEL_SPACING_DBL, GEL_SPACING_DBL, GEL_GROUP_4_SCREEN_WIDTH_MIN, GEL_SPACING_TRPL, GEL_GROUP_3_SCREEN_WIDTH_MIN, GEL_GROUP_3_SCREEN_WIDTH_MAX, GEL_SPACING_DBL);
export var StoryPromoUl = /*#__PURE__*/styled.ul.attrs({
  role: 'list'
}).withConfig({
  displayName: "StoryPromoUl",
  componentId: "sc-171lqjd-1"
})(["list-style-type:none;margin:0;padding:0;"]);
StoryPromoUl.propTypes = {
  children: node.isRequired
};
StoryPromoLi.propTypes = {
  children: node.isRequired,
  border: bool
};
StoryPromoLi.defaultProps = {
  border: true
};